import { motion, AnimatePresence } from 'framer-motion';
import { useUIStore } from '../../stores/useUIStore';

export default function Toast() {
  const { activeToast, hideToast } = useUIStore();

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-2 pointer-events-none">
      <AnimatePresence>
        {activeToast && (
          <motion.div
            key={activeToast.id}
            initial={{ opacity: 0, y: 20, scale: 0.95 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.95, transition: { duration: 0.2 } }}
            className={`pointer-events-auto flex items-center gap-4 px-5 py-4 min-w-[300px] shadow-2xl rounded-sm ${
              activeToast.type === 'error' ? 'bg-[#C0392B] text-white' : 'bg-[#0F2616] text-white'
            }`}
          >
            {activeToast.image ? (
              <img src={activeToast.image} alt="" className="w-10 h-10 object-cover bg-white/10" />
            ) : (
              <div className="w-6 h-6 flex items-center justify-center text-lg">
                {activeToast.type === 'success' ? '✓' : activeToast.type === 'error' ? '✕' : 'ℹ'}
              </div>
            )}
            
            <p className="flex-1 text-sm font-medium" style={{ fontFamily: 'Jost, sans-serif' }}>
              {activeToast.message}
            </p>

            <button 
              onClick={hideToast}
              className="text-white/50 hover:text-white transition-colors p-1"
              aria-label="Close"
            >
              ✕
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
